// src/components/Contact.js
import React from "react";
import { Container } from "react-bootstrap";

const Contact = () => {
  return (
    <section className="contact-section">
      <Container>
        <h2 className="text-center">Contato</h2>
        <a
          href="https://wa.me/5584988654827" /* Link para o WhatsApp com o número da loja */
          className="whatsapp-button"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" /* Ícone do WhatsApp puxado online */
            alt="WhatsApp"
            width="24"
            height="24"
          />
          Fale conosco no WhatsApp
        </a>
      </Container>
    </section>
  );
};

export default Contact;
